<template>
  <div class=".gg-container-1">
    <div class="search-container">
      <div class="search-container-fn-input">
        <label>文章标题：</label>
        <el-input
          style="width: 200px"
          size="small"
          placeholder="文章标题"
          prefix-icon="el-icon-search"
          clearable
          v-model="searchParams.keywords"
          @change="reset"
        >
        </el-input>
      </div>
			<el-button
				size="mini"
				type="primary"
				style="padding: 6px 7px;margin-left: 5px;margin-right: 20px;
                              background-color: #2362FB; border-color: #2362FB"
				@click="reset"
			>
				<span>查找</span>
			</el-button>
      <div class="search-container-fn-input">
        <label>状态：</label>
        <el-select
          style="width: 200px"
          v-model="searchParams.status"
          clearable
          placeholder="请选择"
          size="small"
          @change="reset"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div
        style="margin-left: auto; display: flex; justify-content: space-around"
      >
        <div class="search-container-fn-input">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
									  background-color: #2362FB; border-color: #2362FB"
            @click="editArticle('add')"
            >新增
          </el-button>
        </div>
        <div class="search-container-fn-input" v-if="operateList.indexOf('delete') > -1">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
									  background-color: #2362FB; border-color: #2362FB"
            @click="delArticle(multipleSelectionPres[0])"
            v-if="multipleSelectionPres.length == 1"
            >删除
          </el-button>
        </div>
        <div class="search-container-fn-input" v-if="operateList.indexOf('update') > -1">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
									  background-color: #2362FB; border-color: #2362FB"
            @click="editArticle('edit', multipleSelectionPres[0])"
            v-if="multipleSelectionPres.length == 1"
            >编辑
          </el-button>
        </div>
        <div class="search-container-fn-input" v-if="operateList.indexOf('update_table') > -1">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit-outline"
            style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
										background-color: #2362FB; border-color: #2362FB"
            @click="handleEditTableHead"
            >编辑表头
          </el-button>
        </div>
        <div class="search-container-fn-input" v-if="operateList.indexOf('reset_query') > -1">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
										background-color: #2362FB; border-color: #2362FB"
            @click="handleResetSearch"
            >重置查找
          </el-button>
        </div>
        <!--对应第三方图标的button样式-->
      </div>
    </div>
    <!----------------表格---------------->
    <el-table
      border
      size="mini"
      v-loading="listLoading"
      :header-cell-style="{ 'text-align': 'center' }"
      :data="tableData"
      height="725"
      @selection-change="handleSelectionChange"
      style="width: 100%;z-index:0"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column type="index" align="center" width="50">
      </el-table-column>
      <template v-for="(column, index) in tableHead">
        <el-table-column
          :prop="column.column_prop"
          :label="
            column.column_label_user_definition
              ? column.column_label_user_definition
              : column.column_label
          "
          :width="column.width ? column.width : ''"
          :key="index"
          align="center"
          v-if="column.field_type === 'textBtn' && column.visible === true"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              style="font-size: 12px; color: #2379fb"
              @click.prevent="editArticle('view', scope.row)"
            >
              {{ scope.row[column.column_prop] }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          :prop="column.column_prop"
          :label="
            column.column_label_user_definition
              ? column.column_label_user_definition
              : column.column_label
          "
          :width="column.width ? column.width : ''"
          :key="index"
          align="center"
          v-else-if="column.field_type === 'select' && column.visible === true"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              class="switch"
              @change="changeExamine(scope.row)"
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用"
              active-color="#13ce66"
              inactive-color="#C8C8C8"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          :sortable="tableHeadSortable.includes(column.column_prop)"
          :prop="column.column_prop"
          :label="
            column.column_label_user_definition
              ? column.column_label_user_definition
              : column.column_label
          "
          :width="column.width ? column.width : ''"
          :key="index"
          align="center"
          v-else-if="column.visible === true"
          show-overflow-tooltip
        >
          <template #header>
            <el-popover
              placement="bottom"
              title=""
              min-width="160"
              trigger="click"
              v-if="
                searchTableHead.filter(
                  (item) => item.name == column.column_prop
                ).length > 0
              "
            >
              <span slot="reference" class="search-header">
                <span class="search-title">{{
                  column.column_label_user_definition
                    ? column.column_label_user_definition
                    : column.column_label
                }}</span>
                <i
                  style="margin-left: 3px;font-weight: bolder; font-size: 20px"
                  class="el-icon-search"
                  :class="{
                    isSearch: searchTableHead.filter(
                      (item) => item.name == column.column_prop
                    )[0].isSearch,
                    'el-icon-zoom-in': searchTableHead.filter(
                      (item) => item.name == column.column_prop
                    )[0].isSearch,
                  }"
                />
              </span>
              <el-date-picker
                v-if="'created_at' == column.column_prop"
                v-model="datetimerange"
                type="daterange"
                size="mini"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
              >
              </el-date-picker>
              <el-select
                v-if="'cate_name' == column.column_prop"
                style="width: 200px"
                @change="
                  handleSearch(column.column_prop, searchParams.cate_name)
                "
                v-model="searchParams.cate_id"
                clearable
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in articleCate"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-input
                v-if="'name' == column.column_prop"
                size="mini"
                placeholder=""
                prefix-icon="el-icon-search"
                v-model="searchParams.keywords"
                clearable
                @change="handleSearch(column.column_prop, searchParams.name)"
              >
              </el-input>
            </el-popover>
            <span v-else>{{
              column.column_label_user_definition
                ? column.column_label_user_definition
                : column.column_label
            }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!----------------分页---------------->
    <!--<pagination :total="total" :page.sync="listQuery.page" -->
    <!--						:limit.sync="listQuery.limit"-->
    <!--						@pagination="getList"/>-->

    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
    <!--编辑表头-->
    <editTableHead
      :isActiveEditTableHead.sync="isActiveEditTableHead"
      @_getAdminFieldIndex="_getAdminFieldIndex"
      v-if="isActiveEditTableHead"
      @getList="getList"
      :table_type="table_type"
    >
    </editTableHead>
  </div>
</template>

<script>
import articleListTableHead from "./tableHead/articleListTableHead";
import { getAdminFieldIndex } from "@/api/drugs2.0";
import Pagination from "@/components/Pagination";
import editTableHead from '@/components/editTableHead/editTableHead'
import {
  articleList,
  saveStatusArticle,
  delArticle,
  merchantsList,
} from "@/api/article";
import { mapGetters,mapState } from "vuex";

export default {
  name: "articleList",
  components: {
    Pagination,
    editTableHead,
  },
  computed: {
    ...mapGetters(["adminId"]),
    ...mapState({
      table_options: (state) => state.user.table_options,
    }),
    dialogTitle() {
      return (
        {
          add: "添加",
          edit: "编辑",
        }[this.openType] || "添加"
      );
    },
  },
  activated() {
    this.getList();
  },
  async created() {
    await this._getAdminFieldIndex();
    this.getList();
    //  this.getMerchantsList()
  },
  mounted() {
    this.$store.dispatch("user/getOperates", this.$route.path).then((res) => {
      this.operateList = res;
    });
  },
  data() {
    return {
      table_type: "articleList",
			  operateList: [],
      isActiveEditTableHead: false,
      multipleSelectionPres: [],
      multipleSelection: [],
      activities: [],
      tableHead: [],
      searchTableHead: [
        //控制搜索
        {
          name: "title",
          isSearch: false,
        },
        {
          name: "created_at",
          isSearch: false,
        },
        {
          name: "cate_name",
          isSearch: false,
        },
        {
          name: "status",
          isSearch: false,
        },
      ],
      tableHeadSortable: [
        //控制排序
        "created_at",
        "expired_at",
        "next_visit_at",
        "end_visit_at",
        "end_order_at",
      ],
      datetimerange: "",
      searchParams: {},
      currInfo: {},
      openType: "",
      total: 0,
      articleCate: [
        {
          id: 31,
          title: "患者端文章",
        },
        {
          id: 37,
          title: "医生端文章",
        },
      ],
      merchantsListDropDownData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 100,
        agent_id: "",
        importance: undefined,
        title: undefined,
        type: undefined,
        sort: "+id",
      },
      statusOptions: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      tableData: [],
      dialogCateVisible: false,
      cateDropDownData: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val, "val");
      this.multipleSelection = [];
      this.multipleSelectionPres = [];
      val.forEach((item) => {
        this.multipleSelection.push(item.id);
        this.multipleSelectionPres.push(item);
      });
    },
    handleSearch(prop, value) {
      console.log(prop, value, "2312343");
      this.searchTableHead.forEach((item) => {
        if (item.name == prop) {
          if (value == "") {
            item.isSearch = false;
          } else {
            item.isSearch = true;
          }
        }
      });
      this.getList("restPage");
    },
    handleResetSearch() {
      this.searchParams = {
        is_wx: "",
        visit_level: "",
        buy_count: "",
      };
      this.searchTableHead.forEach((item) => {
        item.isSearch = false;
      });
      this.choiceDateCreateRecord = [];
      this.choiceDateExpire = [];
      this.choiceDateEndVisit = [];
      this.choiceDateEndOrder = [];
      this.choiceDateNextVisit = [];
      this.getList("restPage");
    },
    handleEditTableHead() {
      this.isActiveEditTableHead = true;
    },
    async _getAdminFieldIndex() {
      // try {
      //   this.listLoading = true;
      //   var params = {
      //     type: "articleList",
      //   };
      //   const res = await getAdminFieldIndex(params);
        this.tableHead = this.table_options.articleList;
      //   console.log(this.tableHead);
      // } catch (err) {
      //   //在此处理错误
      // } finally {
      //   this.listLoading = false;
      // }
    },
    getMerchantsList() {
      merchantsList()
        .then((response) => {
          let data = response;
          if (data.code == 200) {
            let _data = data.data;
            console.log(_data);
            this.merchantsListDropDownData = _data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getList(page) {
      this.listLoading = true;
      if (!(page && page.page)) {
        this.listQuery.page = 1;
      }
      let params = { ...this.searchParams };
      params.page = this.listQuery.page;
      params.page_size = this.listQuery.limit;
      articleList(params)
        .then((response) => {
          let data = response;
          if (data.code == 200) {
            let _data = data.data;
            this.total = _data.total;
            this.listQuery.limit = Number(_data.per_page);
            this.tableData = _data.list;
          }
          this.listLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.listLoading = false;
        });
    },
    editArticle(type, item) {
      this.openType = type;
      if (type === "add") {
        this.$router.push({
          path: "/articleManage/articleDetail",
          query: { type: type },
        });
      } else {
        this.currInfo = { ...item };
        if (!item) {
          this.$message({
            type: "error",
            message: "请选择要编辑的文章",
          });
          return;
        }
        this.$router.push({
          path: "/articleManage/articleDetail",
          query: {
            type: type,
            article_id: item.article_id,
            agent_id: item.agent_id,
          },
        });
      }
    },
    delArticle(item) {
      this.$confirm(`是否删除文章 "${item.title}"?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let params = {};
          params.article_id = item.article_id;
          delArticle(params)
            .then((response) => {
              let data = response;
              if (data.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: data.msg + "," + data.code,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    changeExamine(row) {
      //选择状态 (启用/禁用)
      console.log(row.status);
      this.listLoading = true;
      const data = {
        article_id: row.article_id,
        type: row.status,
      };
      saveStatusArticle(data)
        .then((response) => {
          let data = response;
          console.log(data);
          if (data.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            // this.getList()
          }
          this.listLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: "error",
            message: "修改失败!",
          });
          this.listLoading = false;
        });
    },
    reset() {
      // this.searchParams = {};
      this.listQuery.page = 1;
      this.getList();
    },
    // 监听日期选择
    dateChange(val) {
      console.log(val);
      if (val && val.length) {
        this.searchParams.start_at = val[0];
        console.log(val[0]);
        this.searchParams.end_at = val[1];
      } else {
        this.searchParams.start_at = "";
        this.searchParams.end_at = "";
      }
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.treeBox {
  width: 280px;
  flex-shrink: 0;
  margin-right: 20px;
  padding: 0;

  .btnBox {
    i {
      margin-left: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.px-2 {
  padding-left: 20px;
  padding-right: 20px;
}

.py-1 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-2 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.p-2 {
  padding: 20px;
}

.p-1 {
  padding: 10px;
}

.border-bottom {
  border-bottom: 1px solid #ececec;
}

.dot {
  display: inline-block;
  border: 5px solid;
  border-radius: 50%;
  margin: 0 5px;
}

.custom-tree-node {
  font-size: 12px;

  .btnWrap {
    i {
      font-style: normal;
      margin-left: 5px;
    }
  }
}

.filter-tree {
  margin-top: 10px;
}

/* switch按钮样式 */
::v-deep.switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .el-switch__label--right span {
    margin-right: 11px;
  }

  /*关闭时文字位置设置*/
  .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .el-switch__label--left span {
    margin-left: 11px;
  }

  /*显示文字*/
  .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .el-switch__core,
  .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
